import { render, staticRenderFns } from "./generaler.vue?vue&type=template&id=9fce5400&scoped=true&"
import script from "./generaler.vue?vue&type=script&lang=js&"
export * from "./generaler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fce5400",
  null
  
)

export default component.exports